import React, { ReactNode } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { usePopUpNotifications } from 'src/hooks';

type ClipboardControllerProps = {
  children: ReactNode;
  text: string | null;
};

export const ClipboardController = ({
  children,
  text,
}: ClipboardControllerProps) => {
  const { addSuccessNotification, addErrorNotification } =
    usePopUpNotifications();

  if (text === null) {
    return null;
  }

  return (
    <CopyToClipboard
      text={text}
      onCopy={(text, result) => {
        if (result) {
          addSuccessNotification('clipboard.success');
        } else {
          addErrorNotification('clipboard.failed');
        }
      }}
    >
      {children}
    </CopyToClipboard>
  );
};

export default ClipboardController;
